import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { IAddressValue } from '@ifr/form-questionnaire/src/types/Elements';
import QuestConfig, { IQuestConfig } from '@ifr/form-questionnaire/src/types/config';
import Url from '@ifr/form-questionnaire/src/types/url';

export interface IStatus {
  id: number;
  code: string;
  name: string;
  message: string;
  messageError: string;
  final: boolean;
  annulate_app: boolean;
}
class Status implements IStatus {
  id: number;
  code: string;
  name: string;
  message: string;
  messageError: string;
  final: boolean;
  annulate_app: boolean;
  constructor(
    { id = 0, code = '', name = '', message = '', messageError = '', final = false, annulate_app = false }: IStatus = <
      IStatus
    >{},
  ) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.message = message;
    this.messageError = messageError;
    this.final = final;
    this.annulate_app = annulate_app;
  }
}

export interface IApp {
  id: string;
  createDate: string;
  dateOfAccreditation?: string;
  number: string;
  regaddressObject: IAddressValue;
  /*
            "regaddressObject": {
                "text": string|null,
                "value": {}|null
            },
    */
  mapRegaddress: string | null;
  actualaddress: string | null;
  regdate: string | null;
  orgnameshort: string | null;
  orgnamefull: string | null;
  inn: string;
  kpp: string | null;
  ogrn: string | null;
  okpo: string | null;
  legalform: string | null;
  isIndividual: boolean;
  okvedname: string | null;
  office: number | null;
  ownershipform: string | null;
  clientStatus: string | null;
  isAuto: boolean;
  isRafp: boolean;
  shortNumber: string;
}
class App implements IApp {
  id: string;
  createDate: string;
  number: string;
  regaddressObject: IAddressValue;
  mapRegaddress: string | null;
  actualaddress: string | null;
  regdate: string | null;
  dateOfAccreditation?: string;
  orgnameshort: string | null;
  orgnamefull: string | null;
  inn: string;
  kpp: string | null;
  ogrn: string | null;
  okpo: string | null;
  legalform: string | null;
  isAuto: boolean;
  isRafp: boolean;
  shortNumber: string;
  isIndividual: boolean;
  okvedname: string | null;
  office: number | null;
  ownershipform: string | null;
  clientStatus: string | null;

  constructor(
    {
      id = '',
      createDate = '',
      number = '',
      regaddressObject = {
        text: '',
        value: {},
      },
      mapRegaddress = null,
      actualaddress = '',
      regdate = '',
      dateOfAccreditation = '',
      orgnameshort = '',
      orgnamefull = '',
      inn = '',
      kpp = '',
      ogrn = '',
      okpo = '',
      legalform = null,
      isIndividual = false,
      okvedname = '',
      office = 0,
      ownershipform = '',
      clientStatus = '',
      isAuto = false,
      isRafp = false,
      shortNumber = '',
    } = <IApp>{},
  ) {
    this.id = id;
    this.createDate = createDate;
    this.number = number;
    this.regaddressObject = regaddressObject;
    this.mapRegaddress = mapRegaddress;
    this.actualaddress = actualaddress;
    this.regdate = regdate;
    this.dateOfAccreditation = dateOfAccreditation;
    this.orgnameshort = orgnameshort;
    this.orgnamefull = orgnamefull;
    this.inn = inn;
    this.kpp = kpp;
    this.ogrn = ogrn;
    this.okpo = okpo;
    this.legalform = legalform;
    this.isAuto = isAuto;
    this.isRafp = isRafp;
    this.shortNumber = shortNumber;
    this.isIndividual = isIndividual;
    this.okvedname = okvedname;
    this.office = office;
    this.ownershipform = ownershipform;
    this.clientStatus = clientStatus;
  }
}

interface IResponseApp {
  data: IApp;
  status: IStatus;
  message: string | null;
}
interface IAppState {
  app: IApp;
  status: IStatus;
}
export default <Module<IAppState, any>>{
  state: {
    app: new App(),
    status: new Status(),
  },
  mutations: {
    setOfficeId(state, officeId = 0) {
      state.app.office = officeId;
    },
    setAppId(state, id = '') {
      state.app.id = id;
      state.app.shortNumber = id;
    },
    changeApp(state, data: IApp = <IApp>{}) {
      for (let key in data) {
        //@ts-ignore
        state.app[key] = data[key];
      }
    },
    //Этот метод используется при работе с текущей заявкой. Нужен для работы со ссылкой на объект заявки из списка заявок. Для того тчобы в журнале заявок также менялся статус.
    changeAppStatus(state, data: IStatus) {
      const status = new Status(data);
      for (let key in status) {
        //@ts-ignore
        state.status[key] = status[key];
      }
    },
    //Метод вызывается при открытии заявки. Нужен для создания ссылки на объект apps[i] из списка заявок
    setAppStatusLink(state, status: IStatus) {
      state.status = status;
    },
  },
  actions: {
    async getApp({ getters, dispatch, rootGetters }, id: string): Promise<void> {
      if (!id) return Promise.reject();

      if (getters.isApp && getters.appId == id) return Promise.resolve();
      dispatch('setLoader', {
        show: true
      })
      const url = rootGetters.uri.appById(id);
      return axios
        .get<IResponseApp>(url)
        .then((resp) => {
          return dispatch('setApp', resp.data);
        })
        .catch((e) => {
          //Заявка не найдена
          if (new Set([400, 404]).has(e.response?.status)) {
            return Promise.reject(e);
          }

          e.uri = url;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    // createRequest
    setApp({ commit, dispatch }, app: IResponseApp): Promise<void> {
      dispatch('unlockApp');
      commit('changeApp', new App(app.data));
      commit('setAppStatusLink', app.status);
      commit('setAppStep');

      localStorage.setItem('appId', app.data?.id || '');

      return Promise.resolve();
    },
    async annulApp({ state, commit, dispatch, rootGetters }, id = state.app.id): Promise<void> {
      return axios
        .post<IStatus>(rootGetters.uri.annul(id))
        .then((resp) => {
          commit('changeAppStatus', resp.data);
          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.annul(id);
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async getAppStatus({ getters, commit, dispatch, rootGetters }, id = getters.appId): Promise<void> {
      return axios
        .get(rootGetters.uri.status(id))
        .then((resp) => {
          commit('changeAppStatus', resp.data);
          return Promise.resolve();
        })
        .catch((e) => {
          e.uri = rootGetters.uri.status(id);
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async unlockApp({ dispatch, rootGetters }) {
      const appId = localStorage.getItem('appId');

      if (!appId) return Promise.resolve();

      const url = rootGetters.uri.resetClient(appId);
      return axios
        .post(url)
        .catch((e) => {
          e.uri = url;
          dispatch('setError', e);
        })
        .finally(() => {
          return Promise.resolve();
        });
    },
  },
  getters: {
    isApp: (state): boolean => !!state.app.id,
    app: (state): IApp => state.app,
    appId: (state): string => state.app.id,
    getAppShortNumber: ({ app }) => app.shortNumber,
    status: (state): IStatus => state.status,
    finalStatus: (state): boolean => state.status.final,
    appStatusCode: (state): string => state.status.code,
    isSendingDocs(state, getters): boolean {
      return getters.appStatusCode == 'SENDING_DOCS';
    },
    isAddDocs(state, getters): boolean {
      return getters.appStatusCode == 'ADD_DOCS';
    },
    isStep3(state, getters): boolean {
      return getters.isSendingDocs || getters.isAddDocs;
    },

    isIndividual: (state): boolean => state.app.isIndividual,
    isAuto: (state): boolean => state.app.isAuto,
    isAppStatusDenied: (state, getters): boolean => getters.isStatusDenied(getters.appStatusCode),
    isStatusDenied:
      (state) =>
      (code: string): boolean => {
        switch (code) {
          case 'CUST_CANCEL':
          case 'BANK_DECLINE':
          case 'BANK_ANNUL':
          case 'BANK_CANCEL':
            return true;
          default:
            return false;
        }
      },
    isAppStatusAllowed: (state, getters): boolean => getters.isStatusAllowed(getters.appStatusCode),
    isStatusAllowed:
      (state) =>
      (code: string): boolean =>
        code === 'ACC_OPENED',
    config: (state, getters, rootState, rootGetters): IQuestConfig => {
      return new QuestConfig({
        isIndividual: getters.isIndividual,
        isAutomaticApp: getters.isAuto,
        appRegAddress: state.app.regaddressObject,
        appInn: state.app.inn,
        appId: getters.appId,

        isHideOffice: rootGetters.env.HIDE_OFFICE,
        isHideInvitedManager: rootGetters.env.HIDE_INVITED_MANAGER,
        isHideButtonAddParticipants: rootGetters.env.HIDE_ADD_PARTICIPANT,
        isPassportRecognition: rootGetters.env.PASSPORT_RECOGNITION,
        isWorkingWithNonResidents: rootGetters.env.WORKING_WITH_NON_RESIDENTS,
        minCountCounterparties: +rootGetters.env.MIN_NUMBER_COUNTERPARTIES,

        listRegions: rootGetters['step2/bankingRegions'],

        url: new Url({
          recognitionPassport: rootGetters.uri.recognitionPassport(getters.appId),
          addParticipant: rootGetters.uri.participantOfApp.bind(rootGetters.uri),
        }),

        voc: rootGetters.voc,
        clientPhone: rootGetters.userPhone,
        clientEmail: rootGetters.user.email,
        environment: 'LKK',
        baseUrl: axios.defaults.baseURL,
        isOldMode: !rootGetters.env.IS_NEW_QUESTIONNAIRE_MODE,
        isConfirmParentValue: rootGetters.env.QUESTIONNAIRE_CONFIRM_PARENT_VALUE,
        user: rootGetters.user,
        organizationStatusFilter: rootGetters.showOrgStatus,
      });
    },
  },
};
